import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export default function HowItWorks({ t }) {
  return (
    <section
      id="how"
      data-testid="how-it-works-section"
      className="relative mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-36"
    >
      <motion.p
        initial={{ opacity: 0, y: 14 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: EASE }}
        className="font-mono text-xs uppercase tracking-[0.25em] text-[#00F562]"
      >
        {t.how.overline}
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.1, ease: EASE }}
        className="mt-4 max-w-2xl font-display text-2xl font-extrabold uppercase tracking-tight sm:text-3xl lg:text-4xl"
      >
        {t.how.title}
      </motion.h2>

      <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-3">
        {t.how.chapters.map((c, i) => (
          <motion.article
            key={c.n}
            data-testid={`how-chapter-${c.n}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.15, ease: EASE }}
            whileHover={{ y: -6 }}
            className="group relative overflow-hidden rounded-2xl border border-white/[0.08] bg-[#0D111A] p-8 transition-colors duration-500 hover:border-[#00F562]/40"
          >
            <div className="pointer-events-none absolute -right-8 -top-8 h-32 w-32 rounded-full bg-[#00F562]/0 blur-2xl transition-all duration-700 group-hover:bg-[#00F562]/15" />
            <span className="th-text-outline font-display text-6xl font-black">
              {c.n}
            </span>
            <h3 className="mt-6 font-display text-xl font-bold tracking-tight sm:text-2xl">
              {c.title}
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-slate-400">
              {c.body}
            </p>
            <span className="mt-8 block h-px w-full bg-gradient-to-r from-[#00F562]/50 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
          </motion.article>
        ))}
      </div>
    </section>
  );
}
